import { createIntl, createIntlCache, IntlShape } from "react-intl";
import { store } from "../../store/configureStore";
import { getLocaleString } from "../../store/localization/selectors";
import { LangCode } from "../../requests/localization/types";
import csMessages from "../../assets/localization/messages_cs/messages_cs";
import enMessages from "../../assets/localization/messages_en/messages_en";

export const localeDict = {
  cs: createIntl(
    { locale: LangCode.Czech, messages: csMessages },
    createIntlCache()
  ),
  en: createIntl(
    { locale: LangCode.English, messages: enMessages },
    createIntlCache()
  ),
};

class StaticIntlManager {
  locale: LangCode = LangCode.Czech;

  constructor() {
    // Nemůžu udělat ten store.subscribe kvůli circular dependencies problému,
    // nechci hledat, jak přesně k tomu dochází, tohle řešení je good enough :D
    const intervalId = setInterval(() => {
      if (store === undefined) return;
      store.subscribe(this.onStoreChange);
      clearInterval(intervalId);
    }, 50);
  }

  get intl() {
    return localeDict[this.locale];
  }

  onStoreChange = () => {
    const newLocale = getLocaleString(store.getState());
    if (this.locale === newLocale) return;
    this.locale = newLocale;
  };
}

const manager = new StaticIntlManager();

// Nemůžu vyexportovat manager.intl, protože tim bych z toho udělal statickou
// hodnotu, která by nijak nereagovala na změny ve storu. Exportuju proxy,
// co přistupuje k manager.intl on the fly
const staticIntl = new Proxy(
  {},
  {
    get(_, key: keyof IntlShape) {
      return manager.intl[key];
    },
  }
) as IntlShape;

export default staticIntl; // staticIntl;
